import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Old WordPress page with 20 referring domains (Ahrefs, 1 Oct 2026). The
// doctor it introduced is Dr. James Harris. The "_" keeps /why-restore/ a
// normal page, not a layout.
export const Route = createFileRoute("/why-restore_/meet-the-doctor")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/doctors/dr-james-harris/", location.searchStr), statusCode: 301 });
  },
});
